module.exports = __webpack_public_path__ + "img/pic_new_features_5.01fd4610.png";